import { http, delayIt, useMockType as useMock } from './base';
import { AxiosResponse } from 'axios';
import { LkResponse } from './interface';
import { checkReferrer, PASSPORT_URL } from '@/utils/uri';
import { get } from 'lodash';
import Cookie from 'js-cookie';

/**
 * rc 登录
 */
function getRcUrl(url: string) {
  // 生产环境 PASSPORT_URL === 'https://passport.linkdoc.com';
  if (process.env.NODE_ENV !== 'production') {
    return url;
  } else {
    return `${PASSPORT_URL}${url}`;
  }
}

function getData() {
  return new URLSearchParams([['ticket', Cookie.get('user_ticket') as string]]);
}


export function getUserInfo(projectId?: string|number) {
  if (process.env.NODE_ENV !== 'production' && useMock() === 'local') {
    return delayIt(() => {
      return {
        'success': true,
        'data': {
          'uid': 1,
          'userName': 'id voluptate',
          'mobile': 'voluptate',
          'lastLoginTime': 'ipsum in',
          'ucId': 66811176,
          'backPermission': false,
          'frontPermission': false,
          'siteList': [
            {
              'id': 1,
              'projectId': 24350386,
              'siteCode': 'sunt ad in qui elit',
              'siteName': 'ullamco dolore commodo mollit do',
              'siteStatus': 'velit veniam'
            },
            {
              'id': 53934641,
              'projectId': 1443762,
              'siteCode': 'aliqua non enim deserunt',
              'siteName': 'dolor aute amet dolor',
              'siteStatus': 'ut dolore laborum '
            }
          ]
        }
      };
    });
  }

  if (process.env.NODE_ENV !== 'production' && useMock() === 'api.fe') {
    return http.get('http://api.fe.linkdoc.com/mock/507/ucLogin/user/detail');
  }
  return http.get(`/api/sys/user/detail${projectId ? '?projectId=' + projectId : ''}`);
}

export function checkLogin() {
  if (process.env.NODE_ENV !== 'production' && (useMock() === 'local' || useMock() === 'api.fe')) {
    return delayIt(() => {
      return {
        data: {
          status: 'failed',
          data: {
            id: 1,
            user_real_name: 'Mock User', // eslint-disable-line
          },
        },
      };
    });
  }
  return http.post(getRcUrl('/user/isLogin'),
    getData(),
    {
      withCredentials: true,
      xsrfCookieName: undefined,
    }
  );
}


export function logout() {
  if (process.env.NODE_ENV !== 'production' && useMock() === 'local') {
    return delayIt(() => ({}));
  }

  return http.post(getRcUrl('/user/logout'),
    getData(),
    {
      withCredentials: true,
      xsrfCookieName: undefined,
    }
  );
}


export function keyanLogout() {
  if (process.env.NODE_ENV !== 'production' && useMock() === 'local') {
    return delayIt(() => {
      return {
        status: 200,
        data: {
          success: true
        }
      };
    });
  }
  return http.post('/api/sys/user/logout');
}

export async function keyanLogin() {
  if (process.env.NODE_ENV !== 'production' && useMock() === 'local') {
    return delayIt(() => ({
      data: {
        success: false,
        data: {
          backPermission: true,
          frontPermission: true,
          lastLoginTime: '2021-03-24 18:27:50',
          mobile: '13012340000',
          uid: 35,
          userName: '占苍穹',
          id: 1,
        }
      }
    }));
  }

  let response;

  try {
    response = await http.get('/api/sys/user/detail');
  } catch (e) {
    if (get(e, 'response.status') === 401) {
      checkReferrer();
    }
    throw e;
  }

  return response;
}


export function getMenus() {
  if (process.env.NOE_ENV !== 'production') {
    return delayIt(() => {
      return {
        data: [
          {
            name: '项目区',
            key: 'projectArea',
            menus: [
              {title: '脚手架介绍', key: 'Home', icon: 'PieChartOutlined', to: {name: 'Home', href: '/'}},
              {title: 'TypeScript介绍', key: 'AboutTs', icon: 'MailOutlined', level: 1, to: {name: 'AboutTs', href: '/typescript-intruduction'}},
              {
                title: '设置多级导航',
                key: 'pageA',
                icon: 'sub-icon1',
                level: 1,
                children: [
                  {title: '子导航1-1', key: 'pageA.1', icon: 'MailOutlined', to: {name: 'a', href: '/'}},
                  {title: '子导航1-2', key: 'pageA.2', icon: 'DesktopOutlined', level: 2, to: {name: 'b', href: '/typescript-intruduction'}},
                  {title: '子导航1-3', key: 'pageA.3', icon: 'DesktopOutlined', level: 2, children: [
                    {title: '孙导航1-3-1', key: 'pageA.list', icon: 'DesktopOutlined', to: {name: 'c', href: '/pageA/list'}},
                  ]},
                ]
              },
              {
                title: '路由介绍',
                key: 'AboutRouter',
                icon: 'sub-icon2',
                children: [
                  {
                    title: '子导航1-1',
                    key: 'AboutRouter.1',
                    icon: 'MailOutlined',
                    to: {name: 'a', href: '/'}
                  },
                  {
                    title: '子导航1-2',
                    key: 'AboutRouter.2',
                    icon: 'DesktopOutlined',
                    to: {name: 'AboutRouter.2', href: '/router-intruduction'}
                  },
                ]
              },
              {title: 'Error页面', key: '404error', icon: 'AppstoreOutlined', to: {name: '404error', href: '/404error'}},
            ]
          },
          {
            name: '配置区',
            key: 'configArea',
            menus: [
              {
                title: '成员分中心',
                key: 'memberCenter',
                icon: 'MailOutlined',
                to: {name: 'memberCenter', href: '/typescript-intruduction'}
              },
              {
                title: '配置',
                key: 'manage',
                icon: 'sub-icon1',
                level: 1,
                children: [
                  {
                    title: '角色权限',
                    key: 'manage.role',
                    icon: 'DesktopOutlined',
                    level: 2,
                    children: [
                      {
                        title: '孙导航1-3-1',
                        key: 'manage.role.permission',
                        icon: 'DesktopOutlined',
                        to: {name: 'manage.role.permission', href: '/pageA/list'}
                      },
                    ]
                  },
                ]
              },
            ]
          }
        ],


      };
    }, { delay: 30 });
  }
  // if (process.env.NODE_ENV !== 'production' && useMock() === 'api.fe') {
  //   return http.get('http://api.fe.linkdoc.com/mock/175/api/articles');
  // }
}

export function getAppConfig() {
  return delayIt(() => {
    return {
      success: true,
      data: {
        theme: 'dark',
        layout: 'horizontal',
      }
    };
  }, {delay: 150});
}

// 私有化部署登录接口
export function ircLogin(params: object) {
  if (process.env.NODE_ENV !== 'production') {
    return delayIt(() => {
      return {
        data: {
          'code': 0,
          'message': 'success',
          'data': {
            'id': 1,
            'name': 'admin',
            'realName': '私有化部署',
            'mobile': '11111111114',
            'departmentId': 1,
            'titleId': 1,
            'hospitalId': 0,
            'createdBy': 1,
            'updatedBy': 1,
            'apiToken': 'KGsexfZh5hk0msWyKJOzMTUyODk0NTk3MQm1mIE0ohv4Cn9iH3JdyYDusOi8',
            'rememberToken': 'YqEVwlTzEvUtob4yvkBxMTUyODk0NTk3MQXnwWCQBJXluLgZfeNsV3ZKSNTs',
            'createdAt': '2018-05-31 14:04:46',
            'updatedAt': '2018-06-14 11:12:51',
            'deletedAt': null
          }
        }
      };
    });
  }

  return http.post('/irc/users/login', params);
}

export interface ModifyPwdQo {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

// irc私有化部署修改密码接口
export function changeIrcPass(params: object) {
  if (process.env.NODE_ENV !== 'production') {
    return delayIt(() => {
      return {
        data: {
          'code': 0,
          'message': 'success',
          'data': {
            'id': 1,
            'name': 'admin',
            'realName': '私有化部署',
            'mobile': '11111111114',
            'departmentId': 1,
            'titleId': 1,
            'hospitalId': 0,
            'createdBy': 1,
            'updatedBy': 1,
            'apiToken': 'KGsexfZh5hk0msWyKJOzMTUyODk0NTk3MQm1mIE0ohv4Cn9iH3JdyYDusOi8',
            'rememberToken': 'YqEVwlTzEvUtob4yvkBxMTUyODk0NTk3MQXnwWCQBJXluLgZfeNsV3ZKSNTs',
            'createdAt': '2018-05-31 14:04:46',
            'updatedAt': '2018-06-14 11:12:51',
            'deletedAt': null
          }
        }
      };
    });
  }

  return http.put('/irc/users/modifyPassword', params);
}


// 私有化部署修改密码接口
export function changeNucPass(params: ModifyPwdQo): Promise<AxiosResponse<LkResponse<boolean>>> {
  if (process.env.NODE_ENV !== 'production' && useMock() === 'local') {
    return delayIt(() => {
      return {
        data: {
          'code': 0,
          'message': 'success',
          success: true,
        },
      };
    });
  }

  return http.post('/api/sys/user/modifyPassword', params);
}

// 请求隐私政策协议内容
export function getPrivacyPolicyAgreement(agreementType: string) {
  if (process.env.NODE_ENV !== 'production' && useMock() === 'local') {
    return delayIt(() => {
      const agreementContent = [
        {
          title: '提示条款',
          p: '零氪科技（北京）有限公司（以下简称“零氪”或“我们”）非常重视用户（“您”）的个人信息及隐私保护。本隐私协议涉及在您与使用我们平台或平台服务的过程中我们可能接触到您的个人信息的收集、存储、使用、分享您的个人信息。\n'
          + '同时，我们会通过《隐私政策》(以下简称“本政策”)向您说明，我们如何为您提供访问、更新、管理和保护您的个人信息的服务。在使用我们产品或服务前,请您务必仔细阅读并透彻理解本政策,特别是以粗体/粗体下划线标识的条款,您应重点阅读,在确认充分理解并同意后再开始使用。'
        },
        {
          title: '一、我们收集您信息的范围和方式',
          p: '在您使用我们服务的过程中,我们可能会收集、储存和使用与您相关的信息。我们收集您的必要的个人信息的主要目的是为了尽可能为用户您提高服务质量。如果您不提供相关信息，可能无法享受我们提供的某些服务。我们信息收集的范围和方式主要包括：\n'
            + '1，您向我们提供的信息。在为您注册帐户时，您需要向我们提供您的个人信息，包括您的姓名、电话号码。如您需要向我们平台上传患者数据信息,需确保这些数据来源合法合规且取得了所有适用和必要的授权。如果对提供的患者数据管理有特殊要求,您需要征得医院的同意。在必要的情况下,您应提供知情同意书、伦理审批和其它适用的批文用以证明其数据和信息来源的合法和合规性。如需要将相关数据开展研究项目,您同意确保在患者同意的范围内开展研究项目,且开展研究项目的行为符合所有适用的法律法规的规定并已取得相关的审批(如适用)否则本平台有权要求您承担由此造成的全部损失。\n'
            + '2，使用我们服务过程中可能收集的信息。您浏览我们网站以及使用我们提供的服务时，我们可能会收集以下信息：\n'
            + '①　日志信息\n'
            + '当您使用我们的服务或查看由我们提供的服务内容时，我们可能会收集某些信息储存到服务器日志中。此类信息包括：\n'
            + '您对我们服务的详细使用情况，例如您的搜索查询内容，以及您在使用我们服务时浏览或提供的信息和内容详情；\n'
            + '您通过我们的服务分享的信息（元数据），例如发布的文字；\n'
            + 'IP 地址；\n'
            + '设备事件信息，例如浏览器类型、浏览器语言、您提出请求的日期和时间以及引荐网址。可唯一标识您的浏览器或我们帐户的Cookie。\n'
            + '②　本地存储\n'
            + '我们可能会使用浏览器网络存储等机制（包括 HTML 5）和应用程序数据缓存，在您的授权下收集您设备上的信息（包括个人信息）并进行本地存储。当您链接到网络上，您的信息会被自动转移和储存在第三方服务器上，该第三方服务器位于中国境内并为我们所信任。当您使用我们的服务提供信息时，您确认并同意该等信息会被传输、托管以及储存在前述的第三方服务器上。该第三方服务器会依据我们与其签订的协议以及法律法规的要求对您提供的信息进行保密。\n'
            + '③　Cookie 和匿名标识符\n'
            + '当您使用我们服务时，我们可能会通过采取各种技术来收集和存储您访问我们服务的相关数据，在此过程中可能会向您的设备发送一个或多个Cookie 或匿名标识符。当您与我们的合作伙伴进行互动时，我们也会使用 Cookie 和匿名标识符。Cookies是您访问过某一网站后可能存储在您硬盘上的小数据文件，通常包括匿名唯一识别符。Cookie无法从您的硬盘上取得任何其他数据、传播计算机病毒或捕捉您的电子邮件地址。零氪将Cookies用于用户认证、记录用户偏好、需使用用户身份的推广活动、记录受众规模及流量模式、及某些其他目的。我们的电子邮件消息和新闻简报中可能包含跟踪像素，用于确定消息是否被开启以及链接是否确实被查看。您可以通过设置您的设备拒绝我们在您使用服务的过程中收集某些信息，例如您可以将您的浏览器设置为接受cookies、拒绝cookies或在使用cookie时通知您。但是，如果您将您的浏览器设置为拒绝 cookies，您可能将无法使用需要您登陆的零氪产品或服务或利用其全部功能。\n'
            + '3，我们可通过合法途径从其他公共领域取得的您的个人信息。'
        },
        {
          title: '二、我们对所收集信息的使用和共享',
          p: '当您在我们网站和移动应用程序上访问、发布或分享信息时，即表示您允许我们为提供服务之目的而记录、使用并按适用法律和/或服务条款要求处理该等信息。通常，对您的账户有管理权限的我们员工并不监控或查看服务器中存储的您的个人信息或账户内容，但如果我们需要确认是否违反服务条款，或我们有义务审查或向依据法律或适用法规所授予权力行事的其他方提供您的个人信息或账户内容，您授权我们可能会查看您的个人信息或账户内容。 我们可能会出于下列目的使用收集的信息：\n'
            + '1，根据合法、正当、必要的原则,我们将收集为提供本平台服务所必要的个人信息,包括但不限于：（1）您在注册账户时根据平台要求填写的信息,例如姓名、手机号码；（2）您在使用平台或本平台服务时提供或产生的信息,例如您经患者授权提交或披露的患者医疗健康数据、发布的互动交流信息、提交或上传的文件；（3）我们在您使用服务时获取的信息,包括访问日志、客户端 cookie中的资料及您使用本平台服务的记录。\n'
            + '2，根据相关法律法规规定,以下情形中我们在收集您的个人信息之前可能无法征得您的授权同意：（1）与我们履行法律法规规定的义务相关的；（2）与国家安全、国防安全有关的；（3）与公共安全、公共卫生与医疗、重大公共利益有关的；（4）与公共安全、公共卫生与医疗、重大公共利益有关的；（5）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；（6）从合法公开披露的信息中收集个人信息的,如合法的新闻报道、政府信息公开等渠道；（7）法律法规规定的其他情形。\n'
            + '3，用户您同意我们可在以下事项中使用用户您的个人信息：（1）向您提供本平台以及平台服务；（2）平台向用户及时发送重要通知,如软件更新、用户注册协议及本隐私政策条款的变更；（3）平台内部进行审计、数据分析和研究等,以设计、维护、改进平台、本平台服务和与用户之间的沟通；（4）平台为提供更优质的社交体验或保障您的账户安全,向您发送通知、提醒、软件使用建议、风险提示；（5）提供安全保障,包括使用您的个人信息以预防、发现、调查欺诈、危害安全、非法或违反与我们协议、政策或规则的行为,以保护您、我们的其他用户,或我们的合法权益；（6）让您参与有关我们产品和服务的调查,或者报名参与类活动；（7）在不透露单个用户个人身份的前提下对整个用户数据库进行统计分析并对将统计分析结果提供给第三方;(8)经您许可的其他用途。\n'
            + '4，您在使用本平台时,如涉及向未满18周岁的未成年人提供服务或涉及收集、使用未满18周岁的未成年人个人信息或个人隐私数据的,您承诺会严格遵守《儿童个人信息网络保护规定》并在获取其监护人的同意下进行。\n'
            + '5，我们未经用户您同意不向任何第三方公开、透露用户个人信息。但以下特定情形除外：（1）我们为了维护自己合法权益而向您提起诉讼或者仲裁时；（2）为公共安全之目的向第三方披露；（3）我们根据法律法规规定或有权机关的指示提供用户的个人信息；（4）其他本平台根据法律法规规定认为合适的披露。\n'
            + '6，在我们发生合并、收购或破产清算情形,或其他涉及合并、收购或破产清算情形时,如涉及到个人信息转让,我们会要求新的持有您个人信息的公司、组织继续受本政策的约束,否则我们将要求该公司、组织和个人重新向您征求授权同意。'
        },
        {
          title: '三、如何访问、修改或删除您向我们提供的信息',
          p: '1，用户您可以通过咨询相应项目管理员进行访问或者修改您向我们提供的信息。\n'
            + '2，在以下情形中,您可以向我们提出删除您个人信息的请求：（1）如果我们处理个人信息的行为违反法律法规；（2）如果我们收集、使用您的个人信息,却未征得您的明确同意；（3）如果我们处理个人信息的行为严重违反了与您的约定；（4）如果您不再使用我们的产品或服务；（5）如果我们永久不再为您提供产品或服务。\n'
            + '3，若我们决定响应您的删除请求,我们还将同时尽可能通知从我们处获得您的个人信息的主体,并要求其及时删除(除非法律法规另有规定,或这些主体已独立获得您的授权)。当您或我们协助您删除相关信息后,因为适用的法律和安全技术,我们可能无法立即从备份系统中删除相应的信息,我们将安全地存储您的个人信息并将其与任何进一步处理隔离,直到备份可以清除或实现匿名。'
        },
        {
          title: '四、免责声明',
          p: '我们网站及服务可能包含链接至第三方提供的社交媒体网络或其他网站。例如：第三方公司通过在我们服务中进行广告服务或以其他方式向您提供链接，使您可以接入该第三方的服务或网站。该等第三方社交媒体网络或其他网站由非我们控制的第三方运营。当您决定通过“分享”或其他方式打开前述第三方链接时，该等第三方社交媒体或其他网站可能会收集您的个人信息，但是，请您理解，我们对该等第三方如何收集和处理您的个人信息不具有任何控制权，因此您使用该等第三方社交媒体或其他网站时应受该第三方提供的隐私协议及服务条款约束。本《隐私协议》仅适用于您与我们互动过程中所收集的信息，并不适用于任何第三方社交媒体网络或网站提供的服务或第三方社交媒体网络或网站含有的信息或内容。若任何第三方社交媒体网络或网站使用由您提供的信息，我们对此不承担任何责任。'
        },
        {
          title: '五、我们如何保护您的信息',
          p: '1，我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据时受SSL协议加密保护；我们同时对我们的产品和服务提供HTTPS协议安全浏览方式;我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办信息安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。\n'
            + '2，我们以数据为核心、围绕数据生命周期进行的数据安全管理体系,从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。\n'
            + '3，我们会采取合理可行的措施,尽力避免收集无关的个人信息。\n'
            + '4，我们只会在达成本政策所述目的所需的期限内保留您的个人信息,除非法律有强制的存留要求,例如《网络安全法》规定日志信息不少于6个月,《电子商务法》规定交易信息在交易完成日起不少于三年,《互联网信息管理办法》规定记录备份不少于60日。\n'
            + '5，我们判断前述期限的标准包括:(1)完成与您相关的服务、交易目的、维护相应交易及业务记录、应对您可能的查询或投诉;(2)保证我们为您提供服务的安全和质量;(3)您是否同意更长的留存期间;(4)是否存在保留期限的其他特别约定。在您的个人信息超岀保留期间后,我们会根据适用法律的要求删除您的个人信息,或使其匿名化处理。\n'
            + '6，互联网并非绝对安全的环境,使用我们提供的服务时,我们强烈建议您不要使用非我们健康推荐的通信方式发送您的信息。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时,您可以自主选择沟通、交易或分享的对象,作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。\n'
            + '7，我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容,您可通过查看我们公告的方式获知。\n'
            + '8，在不幸发生个人信息安全事件后,我们将按照法律法规的要求向您告知:安全事件的基本情况和可能的影响、我们已釆取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您,难以逐一告知个人信息主体时,我们会采取合理、有效的方式发布公告。\n'
            + '9，同时,我们还将按照监管部门要求,上报个人信息安全事件的处置情况。'
        },
        {
          title: '六、修改与更新',
          p: '我们可能适时修订或更新本《隐私政策》，该等修订或更新构成本《隐私政策》的一部分，同时我们将及时在网页顶部显示更新日期。如果任何修订会实质影响您的权利，我们会向您发送电子邮件或以其他方式及时通知您。鉴于我们的《隐私政策》可能不时修订，我们鼓励您应定期查看以了解我们保护所收集之个人信息的方案及程序的修订是否会影响您的权利。您继续使用我们服务即表示您同意受本《隐私政策》及其任何更新版本的约束。'
        },
        {
          title: '七、联系我们',
          p: '欢迎您对本隐私政策和我们的服务条款提出意见。如有任何问题、投诉、意见或疑虑，请发电子邮件至【linkhub_service@linkdoc.com】，我们将在15个工作日内回复您的请求。'
        }
      ];
      return {
        data: {
          success: true,
          data: {
            createTime: '2022-02-10 12:31:45',
            updateTime: '2022-02-10 12:33:26',
            agreementContent: JSON.stringify(agreementContent),
          }
        }
      };
    });
  }
  return http.get(`/api/sys/agreement/getContent${agreementType ? '?agreementType=' + agreementType : ''}`);
}

// 请求服务协议内容
export function getServiceAgreement(agreementType: string) {
  if (process.env.NODE_ENV !== 'production' && useMock() === 'local') {
    return delayIt(() => {
      const agreementContent = [
        {
          title: '',
          p: '注意：\n'
            + '一旦用户您（“用户”是指使用平台的使用者，在本协议中更多地称为您”）在注册页面点击或勾选“阅读并同意接受《用户服务协议》（以下简称“本协议”）及《隐私政策》”相关内容后，即表示您已经阅读并且同意与零氪科技（北京）有限公司（以下简称“零氪”或“我们”）达成协议，并接受本协议中的全部协议条款、《隐私政策》及本平台内公布的其他专项协议或规则的所有条款的约束。本服务协议即在您和我们之间产生法律效力。'
        },
        {
          title: '1、用户资格',
          p: '1.1您确认，在您开始使用/注册过程中使用我方平台服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。\n'
            + '1.2若您不具备前述与您行为相适应的民事行为能力，则应获得您的监护人的知情同意，您及您的监护人应依照法律规定承担因此而导致的相应的责任。特别地，如果您是未成年人，请在您的监护人的同意和指导下访问和/或使用我方平台网站。如果您不能接受本协议，将不能使用我们的平台或服务。'
        },
        {
          title: '2、账号注册与使用',
          p: '2.1您在注册账户或使用平台或本平台服务的过程中，可能需要填写或提交一些必要的信息，如法律法规、规章、规范性文件（以下称“法律法规”）规定的需要填写的身份信息（包括姓名、联系电话）。\n'
            + '2.2如您提交的信息不完整或不符合法律法规的规定，则您可能无法使用本平台服务或在使用本平台服务的过程中受到限制。您应自行诚信向本平台提供注册资料，您确认您提供的注册资料（包括姓名、联系电话）真实、准确、完整、合法有效，您的注册资料如有变动的，应及时更新注册资料。\n'
            + '2.3如果您提供的注册资料不合法、不真实、不准确，您需承担因此引起的相应责任及后果，我们保留终止您使用平台服务的权利。\n'
            + '2.4您完成注册后，将获得一个用户帐号及相应的密码，该用户帐号和密码由用户您负责保管，该账号所有权属于我们，该账号的使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或售卖。'
        },
        {
          title: '3、适用平台',
          p: '3.1本服务协议适用于网页端所提供的服务。您知悉并理解，为享受上述相关服务，您必须自行提供相关上网设备（如：个人电脑、手机、平板电脑或其他设备）并自行负担相关网络使用支付所产生的有关费用。\n'
            + '3.2我们有权向您公告（包括但不限于弹出页面、网站公告、站内消息等方式）以修改、替换、升级与我方平台服务相关的任何软件。如果您不同意或者不接受我方平台服务相关软件的修改、替换、升级，请直接拒绝、停止、取消，否则视为您同意并接受我方平台的所有调整。'
        },
        {
          title: '4、平台服务内容 ',
          p: '网页平台是基于网页端的应用程序，允许您编写电子病历报告表、发布项目，邀请用户加入项目共同接收和查看数据集，并基于收集到的数据进行统计分析的管理平台。'
        },
        {
          title: '5、个人信息主体权利',
          p: '5.1数据所有权。除非另有约定，否则我们不会拥有任何您收集、储存或者通过软件提交的数据包括其中的任何知识产权（统称“数据”）的所有权。\n'
            + '5.2我们将接收、保存、访问、使用和销毁任何的由我们要求或者是与本协议符合的所有适用的数据保护法规要求填的个人信息。未经过您的同意我们不会将您的个人身份信息分享，但法律要求的除外。\n'
            + '5.3根据合法、正当、必要的原则，我们将收集为提供本平台服务所必要的个人信息，包括：（1）您在注册账户时根据平台要求填写的信息，包括姓名、手机号码；（2）您在使用平台或本平台服务时提供或产生的信息，例如您经患者授权提交或披露的患者医疗健康数据、发布的互动交流信息、提交或上传的文件；（3）我们在您使用服务时获取的信息，包括访问日志、客户端 cookie中的资料及您使用本平台服务的记录。\n'
            + '5.4您承认并同意为您的账户下的发生的所有的活动负责，包括：（1）您使用的服务器平台；（2）您使用网页平台（总称您的账户），如果您选择其他个人或者组织（您的账户代表）给予授权、委托或者以其他方式控制共享或者访问您的账户，您要对您的行为承担所有责任。由您的账户代表使用所造成的结果，我们不承担任何责任。您同意我们保留调整您所组织的账户的名称的权利，以避免服务器平台上终端用户的混淆。\n'
            + '5.5您有权访问及管理您的个人信息：（1）访问您的个人信息。您有权访问您的个人信息，但是法律法规规定的例外情况除外；（2）更正或补充您的个人信息。当您发现我们处理的关于您的个人信息有错误时，您有权联系我们做出更正或补充；（3）删除或注销您的个人信息。在以下情形中，您可以联系我们向我们提出删除或注销您个人信息的请求：如果我们处理个人信息的行为违反法律法规;如果我们收集、使用您的个人信息，却未征得您的明确同意；如果我们处理个人信息的行为严重违反了与您的约定；如果您不再使用我们的产品或服务；或您主动注销了账户；如果我们永久不再为您提供产品或服务。\n'
            + '5.6如我们停止运营本平台，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的个人信息进行删除或匿名化处理。'
        },
        {
          title: '6、内容限制',
          p: '6.1您创建的项目。您对您所创建的任何的应用程序的内容负责，对于其中包括的所有内容包括但不限于您上传的所涉项目的所有信息及资料，您保证拥有全部的相关知识产权。我们会让您自主选择是否把您创建的项目发布到平台上。这类发布将遵守您和第三方用户单独约定的许可协议。除非另有约定，您确认并同意我们对由您创建或者发布的任何项目不承担任何责任。\n'
            + '6.2禁止医疗建议。您确认并同意我们仅提供软件服务平台。软件和应用程序中包括的信息仅供参考。软件和相关的内容不应被用作代替由有执照的医疗专业人士所提供的建议。我们对此不负责任，对违反本条款所造成的结果也不承担任何责任。\n'
            + '6.3项目禁用。如果我们收到通知，声称您所发起的项目侵犯了第三方的知识产权，根据相关规定，您的项目将被我们平台禁用。\n'
            + '6.4您的注册账号名称不得有下列情形：\n'
            + '        （1）违反宪法或法律法规规定的。\n'
            + '        （2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的。\n'
            + '        （3）损害国家荣誉和利益的，损害公共利益的。\n'
            + '        （4）煽动民族仇恨、民族歧视，破坏民族团结的。\n'
            + '        （5）破坏国家宗教政策，宣扬邪教和封建迷信的。\n'
            + '        （6）散布谣言，扰乱社会秩序，破坏社会稳定的。\n'
            + '        （7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的。\n'
            + '        （8）侮辱或者诽谤他人，侵害他人合法权益的。\n'
            + '        （9）含有法律、行政法规禁止的其他内容的。\n'
            + '若您以虚假信息骗取账号名称注册，或账号头像、简介等注册信息存在违法和不良信息的，我方有权利采取通知限期改正、暂停使用、注销账号等措施。\n'
            + '6.5您理解并保证不就我方平台服务进行下列禁止的行为，也不允许任何人利用您的账号进行下列行为：\n'
            + '        （1）在注册账号时，或使用我方平台服务时，冒充他人，或您讹称与任何人或实体有联系（包括设置失实的账号名称或接入另一用户的账号）；\n'
            + '        （2）伪造标题或以其他方式操控内容，使他人误认为该内容为我方所传输；\n'
            + '        （3）通过使用任何自动化程序、软件、引擎、网络爬虫、网页分析工具、数据挖掘工具或类似工具，接入我方平台服务、收集或处理通过我方平台服务所提供的内容；\n'
            + '        （4）参与任何“框架”、“镜像”或其他技术，目的是模仿我方平台服务的外观和功能；\n'
            + '        （5）干预或试图干预任何用户或任何其他方接入我方平台服务； \n'
            + '        （6）散播病毒、网络蠕虫、特洛伊木马病毒、已损毁的档案或其他恶意代码或项目；\n'
            + '        （7）未经他人明确同意，分享或发布该等人士可识别个人身份的资料； \n'
            + '        （8）探究或测试我方平台服务、系统或其他用户的系统是否容易入侵攻击，或在其他方面规避（或试图规避）我方平台服务、系统或其他用户的系统的任何安全功能；\n'
            + '        （9）对我方平台服务所用的软件进行解编、反向编译或逆向工程，或试图作出前述行为；\n'
            + '        （10）为破坏或滥用的目的开设多个账号，或恶意上传重复的、无效的大容量数据和信息； \n'
            + '        （11）利用网络从事侵害他人名誉、隐私、知识产权和其他合法权益等活动；\n'
            + '        （12）故意或非故意违反任何相关的中国法律、法规、规章、条例等以及其他具有法律效力的规范及文件；\n'
            + '        （13）破坏我方平台的版权技术保护措施，未经许可盗用我方平台内容，如复制后再分发等。\n'
            + '若您存在以上任一行为的，我方有权利采取通知限期改正、暂停使用、注销账号等措施，您应承担由此产生的任何法律后果和责任。'
        },
        {
          title: '7、免责声明',
          p: '7.1您理解并同意自主选择、使用我方平台并自负由此可能产生的风险。在任何条件下，我方对您使用我方平台或我方平台链接系统的第三方平台（如有）导致的直接、间接、偶然、特殊、关联性损害或利益损失，或由于错误、疏漏、信号中断、文件删除、病毒、网站出错、漏洞导致的直接或间接损害，或由于运行不稳、通信故障、盗窃、破坏或未经授权使用导致的损害不承担任何法律责任。\n'
            + '7.2 我方平台所提供的服务，限于本协议中明确约定的服务内容。\n'
            + '7.3我们不保证软件或者其他相关的内容在您的当地适用。您承认并同意，您有责任确保您在使用的本软件的相关服务时，符合所有相关的地方和国际法律。'
        },
        {
          title: '8、隐私政策',
          p: '我们非常重视用户个人信息的保护，您注册提供的信息将保存于平台系统内，未经您同意，我们不会提交给未经您授权的其他主体。若我们将信息用于本协议未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。具体详情请参阅《隐私政策》。'
        },
        {
          title: '9，协议的变更及终止',
          p: '9.1根据国家法律法规变化及网站运营需要，我们有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本站上即生效，并代替原来的协议。用户可随时登录查阅最新协议；用户有义务不时关注并阅读最新版的协议及网站公告。如用户不同意更新后的协议，可以且应立即停止接受我方平台依据本协议提供的服务；如用户继续使用本网站提供的服务的，即视为同意更新后的协议。我们建议您在使用本站之前阅读本协议及本站的公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。\n'
            + '9.2您也可以在任何时候发邮件【linkhub_service@linkdoc.com】给我们要求我们终止向您提供服务，收到您邮件的邮件后，我们会及时处理您的请求。如果您未能遵守本协议的任何条款或条件，本协议及本协议授予的许可证将自动终止恕不另行通知。一旦终止，您要同意摧毁你拥有的所有的软件的备份。无论出于何种理由终止协议，终止时您都有至少两个星期的时间完全保存您的数据。根据您的要求，在收到您的通知的两周内我们将删除从您的所有的服务器中的应用程序收集而来的数据。这份终端用户协议的条款被合理阅读的时候，都是为了使协议持续下去直到终止，包括但不限制免责声明和责任限制。\n'
            + '9.3协议终止后，我们可根据适用法律的要求删除您的个人信息，或使其匿名化处理。也可依照法律规定的期限和方式继续保存您留存于我方平台的其他内容和信息。'
        },
        {
          title: '10、法律适用、管辖与其他',
          p: '【法律适用】本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国法律；如法律无相关规定的，参照商业惯例及/或行业惯例。\n'
            + '【管辖】您因使用我们服务所产生及与我们服务有关的争议，由我们与您协商解决。协商不成时，任何一方均可向我方住所地有管辖权的人民法院提起诉讼解决。\n'
            + '【条款有效性】本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。\n'
            + '【其他】当您对本协议有任何疑问，您可以通过【linkhub_service@linkdoc.com】联系我们。我们将及时解决您的问题，一般情况下，我们将在十五天内回复。'
        },
      ];
      return {
        data: {
          success: true,
          data: {
            createTime: '2022-02-10 12:31:45',
            updateTime: '2022-02-10 12:33:26',
            agreementContent: JSON.stringify(agreementContent),
          }
        }
      };
    });
  }
  return http.get(`/api/sys/agreement/getContent${agreementType ? '?agreementType=' + agreementType : ''}`);
}

// 私有化部署登录接口
export function getWechatRedirectUrl(params: object) {
  return http.get('/api/patient/wechat/redirect/getAppletUrl', { params });
}